import { ShipToContactPoint } from './shipToContactPoint.model';
import { ShipToParty } from './shipToParty.model';
import { Position } from './position.model';
import { Logistics } from './logistics.model';
import { SenderParty } from './sender-party.model';
import { SenderContactPoint } from './sender-contact-point';
/** Delivery */
export class Delivery {
    /** channel */
    public channel: string;
    /** customerType */
    public customerType: string;
    /** logistics */
    public logistics?: Logistics;
    /** mappedCustomerType */
    public mappedCustomerType: CustomerTypes;
    /** shipToContactPoint */
    public shipToContactPoint?: ShipToContactPoint;
    /** shipToParty */
    public shipToParty?: ShipToParty;
    /** senderParty */
    public senderParty?: SenderParty;
    /** senderContactPoints */
    public senderContactPoints?: SenderContactPoint;
    /** positions */
    public positions: { [key: string]: Position[]; };
    /** tariffCode */
    public tariffCode: string;
    /** tariffName */
    public tariffName: string;
    /** customerStatus */
    public customerStatus?: string;
    /** orderDate */
    public orderDate: string;
    /** secondDeliveryAllowed */
    public secondDeliveryAllowed?: boolean;
    /** shipmentNumber */
    public shipmentNumber?: string;
    /** status */
    public status: DeliveryStatus;
    /** groups */
    public groups?: DeliveryGroupModel;
    /** salesOrganization */
    public salesOrganization?: string;
    /** salesChannel */
    public salesChannel?: string;
    /** isEnterprise */
    public isEnterprise?: boolean;
    /** emailAddress */
    public emailAddress?: string;
    /** salesOrderType */
    public salesOrderType?: string;
    /** postalShopping */
    public isPostalShopping?: boolean;
    /** customPostalShoppingPositions */
    public customPostalShoppingPositions?: { [key: string]: Position[]; };
}

/** CustomerTypes */
export enum CustomerTypes {
    Tiger = 'Tiger',
    Lion = 'Lion',
    Snowlion = 'Snowlion',
    Leopard = 'Leopard',
    Snowleopard = 'Snowleopard',
    Snowtiger = 'Snowtiger',
    Rabbit = 'Rabbit',
    Python = 'Python',
    Cobra = 'Cobra',
    Monkey = 'Monkey',
    Panda = 'Panda',
    Elephant = 'Elephant',
    Colibri = 'Colibri',
    Polarbear = 'Polarbear',
    SnowNeoLion = 'SnowNeoLion',
    SnowNeoLeopard = 'SnowNeoLeopard',
    NeoLion = 'NeoLion',
    NeoLeopard = 'NeoLeopard',
    BabyElephant = 'BabyElePhant',
    NeoTiger = 'NeoTiger',
    SnowPolarbear = 'SnowPolarbear',
    Giraffe = 'Giraffe',
    Fox = 'Fox',
    Deer = 'Deer',
    Camel = 'Camel',
    Cheetah = 'Cheetah' ,
    Moose = 'Moose',
    Buffalo = 'Buffalo',
    Dolphine ='Dolphine',
}

/** DeliveryStatus */
export enum DeliveryStatus {
    _5 = 'in delivery',
    _6 = 'delivered',
    _7 = 'delivery failed',
    _0 = 'return request',
}
/** DeliveryGroupModel */
export interface DeliveryGroupModel {
    [key: string]: {
        [key: string]: {
            /** positon */
            position: Position,
            /** quanitiy */
            quantity: number,
        }[],
    };
}
